export default {
  RESET_APP: 'RESET_APP',
};
